// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Statistics_wrapper__1r0dy"};